// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","updateInvestmentPreferences":"OCgIKW69gDvu5IhbXOoMg"};